// theme.js — Lapistics MUI theme
// Extracted from App.js (A1 modularisation, Session 17)
// Import: import theme from './theme';

import { createTheme } from '@mui/material';

const theme = createTheme({
  palette: {
    primary:    { main: '#006D77', dark: '#012F3F', light: '#00A3B1', contrastText: '#FFF8ED' },
    secondary:  { main: '#E8C547', dark: '#C9A420', contrastText: '#012F3F' },
    background: { default: '#F5EFE2', paper: '#FFFFFF' },
    text:       { primary: '#0D2030', secondary: '#5A7080' },
    success: { main: '#2D9B5A' },
    warning: { main: '#E8C547' },
    error:   { main: '#D94F4F' },
  },
  typography: {
    fontFamily: "'Outfit', 'Roboto', 'Helvetica', sans-serif",
    h4: { fontWeight: 800, letterSpacing: '-.02em' },
    h5: { fontWeight: 700, letterSpacing: '-.015em' },
    h6: { fontWeight: 700, letterSpacing: '-.01em' },
    button: { fontWeight: 700, letterSpacing: '-.01em' },
  },
  shape: { borderRadius: 14 },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        '@import': "url('https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700;800;900&display=swap')",
        // Session 121: Ram asked for a design opinion on the global page
        // background. Verdict: keep the cream (#F5EFE2) — it's the right
        // brand base and already differentiates from generic white MUI
        // dashboards — but it read as too flat/plain because the diagonal
        // texture was extremely subtle (.025 opacity) and there was nothing
        // giving white Cards any "lift" beyond box-shadow alone. Two changes,
        // both fixed-to-viewport so every screen inherits them for free:
        // 1) diagonal hairline texture opacity bumped .025 → .04 (still
        //    subtle, just more perceptible depth behind cards)
        // 2) two soft ambient gradient blooms added underneath — teal
        //    top-left, gold bottom-right — reusing the exact same radial-
        //    glow trick already used on every hero banner (EventCard,
        //    Dashboard, Results, etc.), just at whole-page scale and far
        //    lower opacity (4%/3%) so it reads as ambient light, not a
        //    visible shape. Multiple background-image layers stack via
        //    comma-separation; texture stays on top, blooms sit behind it.
        body: {
          backgroundImage: [
            'repeating-linear-gradient(-32deg,',
            '  rgba(0,109,119,.04) 0px,',
            '  rgba(0,109,119,.04) 1.5px,',
            '  transparent 1.5px,',
            '  transparent 52px),',
            'radial-gradient(ellipse 900px 700px at 0% 0%,',
            '  rgba(0,109,119,.06) 0%, transparent 65%),',
            'radial-gradient(ellipse 800px 650px at 100% 100%,',
            '  rgba(232,197,71,.05) 0%, transparent 65%)',
          ].join(''),
          backgroundAttachment: 'fixed',
        },
      },
    },
    MuiAppBar: { styleOverrides: { root: {
      background: 'linear-gradient(105deg, #012F3F 0%, #006D77 100%)',
      boxShadow: '0 2px 16px rgba(1,47,63,.25)',
    }}},
    MuiButton: { styleOverrides: {
      root: { borderRadius: 10, textTransform: 'none', fontWeight: 700, fontFamily: "'Outfit', sans-serif", letterSpacing: '-.01em' },
      containedPrimary: {
        background: 'linear-gradient(135deg, #006D77 0%, #008A96 100%)',
        boxShadow: '0 3px 12px rgba(0,109,119,.3)',
        '&:hover': { background: 'linear-gradient(135deg, #005A63 0%, #006D77 100%)', boxShadow: '0 6px 20px rgba(0,109,119,.38)' },
      },
      containedSecondary: { color: '#012F3F', fontWeight: 800 },
    }},
    MuiCard: { styleOverrides: { root: { borderRadius: 16, boxShadow: '0 2px 16px rgba(0,109,119,.08)', border: '1px solid rgba(0,109,119,.07)' }}},
    MuiPaper: { styleOverrides: { root: { backgroundImage: 'none' }}},
    MuiTableCell: { styleOverrides: { head: {
      fontWeight: 700, color: '#012F3F', background: 'rgba(0,109,119,.05)',
      fontSize: '0.82rem', letterSpacing: '.04em', textTransform: 'uppercase',
    }}},
    MuiChip: { styleOverrides: { root: { fontWeight: 600, fontFamily: "'Outfit', sans-serif" }}},
    MuiTab:  { styleOverrides: { root: { fontWeight: 700, fontFamily: "'Outfit', sans-serif", textTransform: 'none', letterSpacing: '-.01em' }}},
    MuiTooltip: { styleOverrides: { tooltip: { background: '#012F3F', fontFamily: "'Outfit', sans-serif", fontSize: '0.8rem' }}},
  },
});

export default theme;
